import { Component, Vue, Prop } from 'vue-property-decorator';

import { Dictionary } from '../../types/Dictionary';
import { MenuItemDTO } from '../../model/MenuItemDTO';
import { debounce } from '../../../node_modules/@types/lodash-es';
import * as _ from 'lodash';

@Component({
	name: 'wms-menu-header-top'	// necessary because of https://github.com/kaorun343/vue-property-decorator/issues/102
})
export class WmsMenuHeaderTop extends Vue {
	@Prop() menu: MenuItemDTO[];
	@Prop({ default: 0 }) parentId?: number;
	@Prop({ default: 0 }) level: number;
	@Prop({ default: false }) active: boolean;

	openedSubmenus: number[] = [];

	get classes() {
		const classes = [
			`mm-level-${this.level}`
		];

		if (this.level === 0) {
			classes.push('mm-menu-top');
			classes.push('main-menu');
		}

		if (this.active) {
			classes.push('active');
		}

		return classes;
	}

	get items(): any {
		//console.log(this.parentId);
		//debugger;

		if (!this.parentId) this.parentId = 0;

		const currentItems = this.menu
			.filter((item) => (item.parentId === this.parentId && (item.menuLevel == 1 || (item.menuLevel == 0 && item.parentId != 0)) && item.cssClass != "mm-separator-full")) //1 je první úroveň
			.sort((a, b) => a.order - b.order);

		currentItems.forEach(function (currentItem) {
			//nutno zrušit vazbu na objekt....
			var css = JSON.parse(JSON.stringify(currentItem.cssClass.replace('menu-top-visible', '').trim())).toString();
			currentItem.txtId = css
			currentItem.cssClassHref = css
		});

		return currentItems;
	}

	getItemStyle(item: MenuItemDTO) {
		const style: Dictionary<string> = {};

		if (item.decoration) {
			if (item.decoration.startsWith('#')) {
				style['background-color'] = item.decoration;
			} else {
				style['background-image'] = `url(${item.decoration})`;
			}
		}

		return style;
	}

	openTopSubmenu(item: MenuItemDTO, e: any) {
		//console.log(this.openedSubmenus)
		//debugger;


		var isMenuVisibleJq = $("#" + item.txtId).is(':visible');
		console.log(isMenuVisible);
		var isMenuVisible = (item.cssClass.indexOf('menu-top-visible') >= 0)

		item.cssClass = item.cssClass.replace("menu-top-visible", '').trim();
		//nutno zrušit vazbu na objekt....
		item.cssClassHref = JSON.parse(JSON.stringify(item.cssClass)).toString()

		//schováme všechny položky menu
		this.closeTopSubmenu();

		//pokud není menu viditelné, zobrazíme jej
		if (!isMenuVisible) {
			item.cssClass = 'menu-top-visible ' + item.cssClass;
			//console.log("otevřeno");
		}

		if (this.menu.filter((f) => f.parentId === item.id).length > 0) {
			if (this.openedSubmenus.find(f => f === item.id)) {
				this.openedSubmenus = this.openedSubmenus.filter(f => f != item.id);
			}
			else {
				this.openedSubmenus = [];
				this.openedSubmenus.push(item.id);
			}
		}
	}

	closeTopSubmenu() {
		//console.log("zavírám top menu (fce)");
		this.menu.filter((f) => f.cssClass.indexOf('menu-top-visible') >= 0)
			.forEach(menuVisibleItem =>
				menuVisibleItem.cssClass = menuVisibleItem.cssClass.replace("menu-top-visible", '').trim()
			);
	}
}

export default WmsMenuHeaderTop;
